/* wagl — design concept "the catalogue"
   One progressive-enhancement script. Every feature is optional: with this file
   absent the pages are complete and readable (html.wg-js is never set, so no
   element starts hidden). No dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var noMotion = function () { return reduce.matches; };

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* 1. header hairline after scroll */
    var header = document.querySelector('[data-wg-header]');
    if (header) {
      var onScrollHeader = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScrollHeader();
      window.addEventListener('scroll', onScrollHeader, { passive: true });
    }

    /* 2. hero slow reveal — wait for the image so the curtain never opens on an empty frame */
    document.querySelectorAll('[data-wg-hero]').forEach(function (hero) {
      var img = hero.querySelector('img');
      var go = function () { requestAnimationFrame(function () { hero.classList.add('is-in'); }); };
      if (noMotion() || !img) { hero.classList.add('is-in'); return; }
      if (img.complete && img.naturalWidth) { go(); }
      else {
        img.addEventListener('load', go, { once: true });
        img.addEventListener('error', go, { once: true });
        setTimeout(go, 2500);
      }
    });

    /* 3. reveal on scroll */
    var reveals = document.querySelectorAll('[data-wg-reveal]');
    if (noMotion() || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* 4. drifting catalogue index — horizontal position follows vertical scroll.
          It uses the track's native scrollLeft, so keyboard focus, touch and
          trackpad scrolling keep working; any direct interaction hands control
          to the visitor. Without JS it is a plain horizontally scrollable list. */
    document.querySelectorAll('[data-wg-drift]').forEach(function (section) {
      var track = section.querySelector('.wg-drift__track');
      var toggle = section.querySelector('[data-wg-drift-toggle]');
      if (!track) return;
      var manual = noMotion();
      var current = track.scrollLeft, target = current, raf = null;
      var setLabel = function () { if (toggle) { toggle.textContent = manual ? (toggle.getAttribute('data-resume') || 'resume drift') : (toggle.getAttribute('data-pause') || 'pause drift'); toggle.setAttribute('aria-pressed', manual ? 'true' : 'false'); } };
      var compute = function () {
        var r = section.getBoundingClientRect();
        var top = r.top + window.scrollY;
        var vh = window.innerHeight;
        var start = Math.max(0, top - vh);              // drift begins when the band enters (or at page top)
        var p = (window.scrollY - start) / (top + r.height - start); // 0 → 1 until the band leaves the top
        p = Math.max(0, Math.min(1, p));
        target = p * (track.scrollWidth - track.clientWidth);
      };
      var tick = function () {
        current += (target - current) * 0.07;
        if (Math.abs(target - current) < 0.4) current = target;
        track.scrollLeft = current;
        raf = (current !== target && !manual) ? requestAnimationFrame(tick) : null;
      };
      var onScroll = function () { if (manual) return; compute(); if (!raf) raf = requestAnimationFrame(tick); };
      var takeOver = function () { if (!manual) { manual = true; if (raf) cancelAnimationFrame(raf); raf = null; setLabel(); } };
      ['wheel', 'touchstart', 'pointerdown', 'focusin', 'keydown'].forEach(function (ev) { track.addEventListener(ev, function (e) { if (ev === 'wheel' && Math.abs(e.deltaX) < Math.abs(e.deltaY)) return; takeOver(); }, { passive: true }); });
      if (toggle) toggle.addEventListener('click', function () { manual = !manual; if (!manual) { current = track.scrollLeft; onScroll(); } setLabel(); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      reduce.addEventListener && reduce.addEventListener('change', function () { if (reduce.matches) takeOver(); });
      setLabel();
      if (!manual) { compute(); current = target; track.scrollLeft = current; }
    });

    /* 5. chapters: hovering or focusing a chapter swaps the plate */
    document.querySelectorAll('[data-wg-chapters]').forEach(function (root) {
      var items = root.querySelectorAll('[data-wg-chapter]');
      var imgs = root.querySelectorAll('[data-wg-plate]');
      var cap = root.querySelector('[data-wg-plate-cap]');
      var activate = function (key) {
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-wg-chapter') === key); });
        imgs.forEach(function (im) {
          var on = im.getAttribute('data-wg-plate') === key;
          im.classList.toggle('is-active', on);
          if (on && cap) cap.textContent = im.getAttribute('data-wg-caption') || '';
        });
      };
      items.forEach(function (it) {
        var key = it.getAttribute('data-wg-chapter');
        it.addEventListener('mouseenter', function () { activate(key); });
        it.addEventListener('focusin', function () { activate(key); });
      });
    });

    /* 6. collection: index / plates view, sort */
    document.querySelectorAll('[data-wg-collection]').forEach(function (root) {
      var views = root.querySelectorAll('[data-wg-view]');
      var viewBtns = root.querySelectorAll('[data-wg-view-btn]');
      var sortBtns = root.querySelectorAll('[data-wg-sort-btn]');
      viewBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-wg-view-btn');
          viewBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          views.forEach(function (el) { el.hidden = el.getAttribute('data-wg-view') !== v; });
          window.__wgView = v; /* in-memory only; Shopify port may persist via cart attribute or URL param */
        });
      });
      if (window.__wgView) { var sb = root.querySelector('[data-wg-view-btn="' + window.__wgView + '"]'); if (sb) sb.click(); }
      sortBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-wg-sort-btn');
          sortBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          root.querySelectorAll('[data-wg-sortable]').forEach(function (list) {
            var kids = Array.prototype.slice.call(list.children);
            kids.sort(function (a, c) {
              var A = a.getAttribute('data-' + key), C = c.getAttribute('data-' + key);
              if (key === 'price' || key === 'no') return parseFloat(A) - parseFloat(C);
              return A.localeCompare(C);
            });
            kids.forEach(function (k) { list.appendChild(k); });
          });
        });
      });
    });

    /* 7. journal contents: mark the current section */
    var toc = document.querySelector('[data-wg-toc]');
    if (toc && 'IntersectionObserver' in window) {
      var links = toc.querySelectorAll('a');
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { links.forEach(function (a) { a.classList.remove('is-current'); a.removeAttribute('aria-current'); }); var l = map[e.target.id]; if (l) { l.classList.add('is-current'); l.setAttribute('aria-current', 'true'); } }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(map).forEach(function (id) { var h = document.getElementById(id); if (h) tio.observe(h); });
    }

    /* 8. concept forms: no backend in the preview. Validate, then confirm in place. */
    document.querySelectorAll('[data-wg-form]').forEach(function (form) {
      var note = form.querySelector('[data-wg-form-note]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        if (input && !input.checkValidity()) { if (note) note.textContent = input.type === 'email' ? 'please enter an email address.' : 'please enter the password.'; input.focus(); return; }
        if (note) note.textContent = form.getAttribute('data-wg-form-done') || 'thank you.';
      });
    });
  });
})();

/* ---------- Shopify port additions ---------- */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  var ROMAN = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x', 'xi', 'xii', 'xiii', 'xiv', 'xv'];
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section'; }

  ready(function () {
    /* a. journal contents built from the article's own h2s (article.content is merchant HTML) */
    document.querySelectorAll('[data-wg-autotoc]').forEach(function (nav) {
      var prose = document.querySelector(nav.getAttribute('data-wg-autotoc'));
      if (!prose) return;
      var hs = prose.querySelectorAll('h2');
      if (hs.length < 2) { nav.hidden = true; return; }
      var ol = nav.querySelector('ol'); var used = {};
      hs.forEach(function (h, i) {
        var id = h.id || slug(h.textContent); while (used[id]) id += '-' + i; used[id] = 1; h.id = id;
        if (nav.hasAttribute('data-wg-number') && !h.querySelector('.wg-num')) {
          var n = document.createElement('span'); n.className = 'wg-num'; n.textContent = (ROMAN[i] || (i + 1)) + '.'; h.insertBefore(n, h.firstChild);
        }
        var li = document.createElement('li'); var a = document.createElement('a'); a.href = '#' + id;
        var s1 = document.createElement('span'); s1.className = 'wg-num'; s1.textContent = (ROMAN[i] || (i + 1)) + '.';
        var s2 = document.createElement('span'); s2.textContent = h.textContent.replace(/^\s*[ivx]+\.\s*/, '');
        a.appendChild(s1); a.appendChild(s2); li.appendChild(a); ol.appendChild(li);
      });
      nav.setAttribute('data-wg-toc', '');
      if ('IntersectionObserver' in window) {
        var links = nav.querySelectorAll('a');
        var tio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (!e.isIntersecting) return;
            links.forEach(function (a) { var on = a.getAttribute('href') === '#' + e.target.id; a.classList.toggle('is-current', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        hs.forEach(function (h) { tio.observe(h); });
      }
    });

    /* b. Track B variant picker: keep price, availability and button state in step with the select */
    document.querySelectorAll('[data-wg-product-form], form.wg-form').forEach(function (form) {
      var select = form.querySelector('select[name="id"]');
      var dataEl = form.querySelector('script[type="application/json"][data-wg-variants]');
      if (!select || !dataEl) return;
      var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var root = form.closest('[data-wg-entry]') || document;
      var priceEl = root.querySelector('[data-wg-price]');
      var btn = form.querySelector('[type="submit"]');
      var soldOut = btn ? btn.getAttribute('data-sold-out') : 'sold out';
      var addLabel = btn ? btn.getAttribute('data-add') : 'add to selection';
      select.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
        if (!v) return;
        if (priceEl && v.price_label) priceEl.textContent = v.price_label;
        if (btn) { btn.disabled = !v.available; btn.firstChild && (btn.firstChild.textContent = v.available ? addLabel + ' ' : soldOut + ' '); }
        if (window.history && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); }
      });
    });
  });
})();
